
/**
 * Global Configuration, i.e. icon path etc.
 *
 * Shared settings for all environments: dev, prod, stage etc.
 */
import { AppConfig } from '../interfaces/app-config.interface';

export const appConfig: AppConfig = {
  iconPath: 'assets/img/icons',
  imagePath: 'assets/img',
  topicPath: 'assets/img/topics',
  logoImg: "assets/img/logo.svg",
  scrollPostion: 50, // To store scroll position
  autoScrollReadableRate: 1,// To store auto scroll readable rate
  appName: 'Tangram',
  mobileHeaderHeight: 200,
  desktopHeaderHeight: 317,
  imageAllowMaxSize: 200000, // Size in Byte, 200 KB
  forumQuestionTextLimit: 300, // question max limit on forum
  dashboardCommentTextLimit: 140 // comment max limit on dashboard
};

/**
 * Display name for the in-app AI assistant. Single source of truth for every
 * user-facing AI label — the underlying model/provider name is an
 * implementation detail and must never surface in the UI. Change it here and
 * every button, tooltip, badge and empty state follows.
 */
export const AI_ASSISTANT_NAME = 'Tangramio AI';

/** Tangram / media metadata limits — keep in sync with tangram API validation */
export const TANGRAM_TITLE_MAX_LENGTH = 100;
export const TANGRAM_DESCRIPTION_MAX_LENGTH = 1000;

// Privacy Options Constants
export const PRIVACY_OPTIONS = {
  PUBLIC: 'public',
  PRIVATE: 'private',
  INVITE_ONLY: 'invite-only',
  PASSWORD_PROTECTED: 'password-protected',
} as const;

export const PRIVACY_DEFAULTS = {
  PRIVACY_OPTION: 'public',
  IS_PASSWORD_PROTECTED: false,
  IS_PRIVATE: false,
  IS_INVITE_ONLY: false,
} as const;